//路由层
const View = resolve => require(["../../components/View.vue"], resolve);

//
// |货币管理
// |——货币储值
// |——
// |——
// |——

/**
 *  货币模块路由表
 */
const storeRouter = {
  path: "store",
  name: "货币管理",
  component: View,
  children: [
    {
      path: "recharge",
      component: () => import("@/view/store/recharge"),
      name: "货币充值"
    },
    {
      path: "dispatch",
      component: () => import("@/view/store/dispatch"),
      name: "货币分配"
    },
  {
      path: "dispatch/:id",
      component: () => import("@/view/store/dispatch"),
      name: "货币分配"
    },
    {
      path: "pricing",
      component: () => import("@/view/store/pricing"),
      name: "价格控制"
    },
    {
      path: "priceRecord",
        component: () => import("@/view/store/priceRecord"),
      name: "价格控制"
    }
  ]


};

export default storeRouter;



// WEBPACK FOOTER //
// ./src/router/modules/store.js